<template>
  <div class="info-box">
    <div class="info-box__text">
      <div class="info-box__text__title">{{title}}</div>
      <div v-if="!link" class="info-box__text__link">{{text}}</div>
      <a :href="text" target="_blank" v-if="link" class="info-box__text__link">{{text}}</a>
    </div>
    <div v-if="copyicon" class="info-box__icon" v-copy="text"></div>
  </div>
</template>

<script>
import { copy } from "@/directives/";
export default {
  props: {
    text: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: "copy"
    },
    copyicon: {
      type: Boolean,
      default: false
    },
    link: {
      type: Boolean,
      default: false
    }
  },
  directives: { copy },
  data() {
    return {};
  },
  watch: {},
  methods: {}
};
</script>